export default "__VITE_ASSET__b45e238c__"